import jwtDecode from 'jwt-decode';
import { TokenExpired, TokenNotFound } from '@/helpers/auth-errors';

export function getTokenExpireDate(token) {
  if (!token) throw new Error('token parameter missed');

  const tokenData = jwtDecode(token);
  const timestamp = String(tokenData.exp).padEnd(13, '0');
  return new Date(+timestamp);
}

export function isExpiredJWT(token) {
  return getTokenExpireDate(token).getTime() <= Date.now();
}

export function findJWTByProfileId(rootGetters, profileId) {
  const childProfile = rootGetters['children/getChildren'].find(c => c.id === profileId);
  if (!childProfile) {
    throw new Error('Child profile with specified profile id not found');
  }

  const childToken = childProfile.jwt;

  const parentAccount = rootGetters['parent/parentAccount'];
  const parentToken = childProfile.parent_id === parentAccount?._id ? parentAccount?.jwt : null;

  if (!childToken && !parentToken) {
    throw new TokenNotFound();
  }

  const expiredChildToken = childToken && isExpiredJWT(childToken);
  if (!childToken || expiredChildToken) {
    if ((!parentToken && expiredChildToken) || isExpiredJWT(parentToken)) {
      throw new TokenExpired();
    }
    return parentToken;
  }
  return childToken;
}
